module.exports = __webpack_public_path__ + "img/hr-garballo-05.2367d11f.png";